<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch03"></a><a id="page_3"></a><a href="#/contents#ch03"><b>Canada</b></a></h2>
<p class="noindent"><span>In the 1940s, the Canadian government advised mothers to begin toilet-training babies at one month old.</span></p>
<p class="noindent"><span>Of Canada’s 36 “Fathers of Confederation,” two of them were named John Hamilton Gray.</span></p>
<p class="noindent"><span>One in ten Canadians say they’d support a law that encouraged people in major cities to wear name tags.</span></p>
<p class="noindent"><span>During World War II, German U-boats sank 23 vessels in Canada’s St. Lawrence River.</span></p>
<p class="noindent"><span>The United States has invaded Canada twice—once during the American Revolution and once during the War of 1812.</span></p>
<p class="noindent"><span>One of Canada’s founding fathers was an American: William P. Howland of Pawling, New York.</span></p>
<p class="noindent"><span>In 1943, Fred Rose became the only Communist ever elected to the Canadian parliament.</span></p>
<p class="noindent"><span>Despite their good-guy image, Canada’s Mounties have been caught spying on people illegally.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?d5eb1c04